import { gql } from "@apollo/client"
import { LikableTeamsFragment } from "@pallet/features/RecruitingTeamType/LikableTeamsList/fragments"

export const PALLET_PARTNERED_TEAMS_QUERY = gql`
    query PalletPartneredTeamsQuery(
        $pallet: String!
        $first: Int!
        $after: String
    ) {
        applylist(slug: $pallet) {
            ... on ApplylistType {
                id
                partneredTeams(first: $first, after: $after) {
                    ...LikableTeamsFragment
                }
            }
        }
    }
    ${LikableTeamsFragment}
`
